export const colors = {
    primary: "#1976d2",
    secondary: "#ff4081",
    background: "#f5f5f5",
    textPrimary: "#212121",
    textSecondary: "#757575",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    lightGray: "#eeeeee",
    darkGray: "#616161",
    white: "#ffffff",
    black: "#000000",
    border: "#dddddd",
    redSubtitle: "#C20A0A",
    bluePrimary: "#1976d2",
    softGray: "#9E9E9E",
    // Modal buttons
    btnSave: "#0FB0C2",
    btnSaveHover: "#2FC8B8",
    btnCancel: "#FF4262",
    btnCancelHover: "#BF4262",
    // Dark mode
    darkBackground: "#181818",
    // Borders and dividers
    lightBorder: "#e0e0e0",
    mediumBorder: "#d0d0d0",
    veryLightGray: "#eeeeee",
    // Text colors
    mediumGray: "#666666",
    lightText: "#fafafa",
    darkGray2: "#333333",
    mediumGray2: "#666666",
    // Transparency variants
    whiteOpacity90: "rgba(255,255,255,0.9)",
    whiteOpacity100: "rgba(255,255,255,1)",
    lightBorderOpacity: "rgba(255,255,255,0.03)",
    darkShadowOpacity40: "rgba(0, 0, 0, 0.4)",
    darkShadowOpacity10: "rgba(0, 0, 0, 0.1)",
    // Primary blue variants
    primaryBlueLight: "rgba(4, 66, 97, 0.58)",
    primaryBlueLighter: "rgba(0, 170, 255, 0.08)",
    // Buttons & links
    buttonBlue: "#0A7BC2",
    // Avatar
    avatarBlueLight: "#e3f2fd",
    avatarDark: "#222c32",
    // Status chips
    statusSuccess: "#2e7d32",
    statusWarning: "#ed6c02",
    statusError: "#d32f2f",
    statusInfo: "#0288d1",
    statusNeutral: "#e0e0e0",
  };
  